module.exports = __webpack_public_path__ + "img/view-bg-button.0934251b.png";